import { format, useState, useEffect, startOfWeek, addDays, isSameDay, lastDayOfWeek, addWeeks, subWeeks, isSameWeek, ChevronLeftRed, ChevronRightRed, PageStyle, CalendarAction, useRouter, CommonAction, React, nb, enUS, sv, da, useTranslation } from '@/imports-files/components/calendar/calendar';


function CalendarWeek(props){
    const router = useRouter();
    const { i18n } = useTranslation();
    const commonAction = new CommonAction();
    const [currentWeek, setCurrentWeek] = useState( commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
    const [selectedDate, setSelectedDate] = useState(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
    const calendarHash = {'current_date': (commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date()), 'is_my_interviews': commonAction.getParamsToUrlWithoutRouter('is_my_interviews') || true, 'selected_tab':'week'};
    const calendarAction = new CalendarAction(props.setCalendarData, calendarHash, router, props.setCalendarDataArray);


    useEffect(()=>{
                     setCurrentWeek(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
                     setSelectedDate(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
                     calendarAction.getCalanderData(calendarHash);
                  }, [props.calandarFlagForRerender])

    const localeMap = {
        en: enUS,
        sv: sv,
        da: da,
        no: nb,
    };

    const getLocale = () => localeMap[i18n.language] || enUS;

    const renderCurrentWeek = () => {
        const daysFormat = "iii";
        const startDate = startOfWeek(currentWeek, { weekStartsOn: 1 });
        const endDate = lastDayOfWeek(currentWeek, { weekStartsOn: 1 });
        const dateFormat = "d";
        const rows = [];
        let days = [];
        let day = startDate;
        let formattedDate = "";
        let ddmmYYDate = "";
        while (day <= endDate) {
          for (let i = 0; i < 7; i++) {
            formattedDate = format(day, dateFormat, {locale: getLocale()});
            ddmmYYDate = commonAction.getDateInDMYFormat(day)
            const cloneDay = day;
            days.push(
              <div
                className={`${PageStyle.CalendarWeek__Cell}
                ${isSameDay(day, selectedDate) ? `${PageStyle.CalendarWeek__Cell__CurrentDay}` : isSameDay(day, selectedDate)
                    ? `${PageStyle.CalendarWeek__Cell__Selected}`: "" } ${calendarAction.greenDotClass(ddmmYYDate, props.calendarDataArray, PageStyle.CalendarMonth__Content__InterviewAvailable)}`}
                key={day}
                onClick={() => {
                  const dayStr = format(cloneDay, "ccc dd MMM yy", {locale: getLocale()});
                  calendarAction.onWeekDateClickHandle(cloneDay, dayStr, setSelectedDate, props.setTodayClick);
                }}>
                <span className={`${PageStyle.CalendarWeek__Cell__DayName}`}>{format(addDays(startDate, i), daysFormat, {locale: getLocale()})}</span>
                <span className={`${PageStyle.CalendarWeek__Cell__Date}`}>{formattedDate}</span>
                {/* <span className="bg">{formattedDate}</span> */}
              </div>

            );
            day = addDays(day, 1);
          }

          rows.push(
            <div className={`${PageStyle.CalendarWeek__Row}`} key={day}>
              {days}
            </div>
          );
          days = [];
        }
        return (
            <>
            <div className={`${PageStyle.CalendarWeek}`}>
            <div className={`${PageStyle.CalendarWeek__LeftIcon}`}>
            <div className={`${PageStyle.CalendarWeek__Icon}`} onClick={()=>
                {
                  calendarAction.changeWeekHandle("prev", currentWeek, setCurrentWeek)
                  let weekStartDay = startOfWeek(subWeeks(currentWeek, 1), { weekStartsOn: 1 })
                  let dayStr = format(weekStartDay, "ccc dd MMM yy", {locale: getLocale()})
                  calendarAction.onArrowClickHandle(weekStartDay, dayStr, props.setTodayClick)
                }}>
                    <span className="chevron-left"><ChevronLeftRed/></span>
                </div>
            </div>
            <div className={`${PageStyle.CalendarWeek__Content}`}>
              <div className={`${PageStyle.CalendarWeek__Content__Body}`}>{rows} </div>
            </div>
            <div className={`${PageStyle.CalendarWeek__RightIcon}`}>
            <div className={`${PageStyle.CalendarWeek__Icon}`} onClick={()=>
              {
                calendarAction.changeWeekHandle("next", currentWeek, setCurrentWeek)
                let weekStartDay = startOfWeek(addWeeks(currentWeek, 1), { weekStartsOn: 1 })
                let dayStr = format(weekStartDay, "ccc dd MMM yy", {locale: getLocale()})
                calendarAction.onArrowClickHandle(weekStartDay, dayStr, props.setTodayClick)
              }}>
                    <span className="chevron-right"><ChevronRightRed/></span>
                </div>
            </div>
        </div>
        {/* <div className="days row">{days}</div> */}
        </>
        );
      };

    return(
        <>
        <div className={`${PageStyle.DateFNS__Calendar}`}>
            {renderCurrentWeek()}
        </div>
        </>
     );
}

export default React.memo(CalendarWeek)
